import React from 'react';
import {
    Alert, Box, Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Stack, TextField
} from '@mui/material';
import LockResetIcon from '@mui/icons-material/LockReset';


export default function ChangePasswordDialog({
  open,
  onClose,
  oldPassword,
  setOldPassword,
  newPassword,
  setNewPassword,
  confirmNewPassword,
  setConfirmNewPassword,
  mdpError,
  mdpSuccess,
  mdpLoading,
  handleChangePassword
}) {
  return (
    <Dialog 
      open={open}
      onClose={(event, reason) => {
        if (mdpError || mdpSuccess) return;
        onClose(event, reason);
      }}
      disableRestoreFocus
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: 390,
          margin: 'auto'
        }
      }}
    >       
      <DialogTitle sx={{ bgcolor: "#f5f7fb", color: "#1976d2", pb: 1.5, mb: 0.5}}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <LockResetIcon color="primary" />
          <span style={{
            fontWeight: 600,
            fontSize: "1.3rem",
            letterSpacing: "0.02em",
            color: "#1976d2",
            alignItems: "center"
          }}>
            Modifier mon mot de passe
          </span>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ pt: 0.5, pb: 2 }}>
        <Stack component="form" onSubmit={handleChangePassword} spacing={1.5}>
          <Box sx={{ height: 32 }} />
          <TextField
            type="password"
            label="Ancien mot de passe"
            fullWidth
            required
            autoFocus
            margin="normal"
            value={oldPassword}
            onChange={e => setOldPassword(e.target.value)}
            size="small"
            disabled={!!mdpSuccess}
          />
          <TextField
            type="password"
            label="Nouveau mot de passe"
            required
            fullWidth
            margin="normal"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            size="small"
            disabled={!!mdpSuccess}
          />
          <TextField
            type="password"
            label="Confirmer le nouveau mot de passe"
            fullWidth
            required
            margin="normal"
            value={confirmNewPassword}
            onChange={e => setConfirmNewPassword(e.target.value)}
            size="small"
            disabled={!!mdpSuccess}
          />
          {mdpError && <Alert severity="error" sx={{ mt: 1 }}>{mdpError}</Alert>}
          {mdpSuccess && <Alert severity="success" sx={{ mt: 1 }}>{mdpSuccess}</Alert>}

          <DialogActions>
            {!mdpSuccess && (
              <>
                <Button onClick={onClose} color="secondary">
                  Annuler
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={mdpLoading}
                >
                  Valider
                </Button>
              </>
            )}
            {mdpSuccess && (
              <Button
                onClick={onClose}
                color="primary"
                autoFocus
                variant="contained"
                disableFocusRipple
                sx={{
                    outline: 'none',
                    boxShadow: 'none',
                    '&:focus, &:focus-visible': {
                        outline: 'none',
                        boxShadow: 'none',
                        backgroundColor: (theme) => theme.palette.primary.main,
                    },
                    '&.Mui-focusVisible': {
                        outline: 'none',
                        boxShadow: 'none',
                    },
                }}
                >
                Fermer
              </Button>
            )}
          </DialogActions>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}